import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'capitalize'
})
export class CapitalizePipe implements PipeTransform {

  transform(value: any, args?: any): any {
    var c = /^(a|e|o|da|de|do|br|n\u00e3o|das|dos|ao|ou|em|um|uma|seu|com|a|an|and|as|at|but|by|en|for|if|in|of|on|or|the|to|vs?\.?|via)$/i;
    return value.toLowerCase().replace(/([^\W_]+[^\s-]*) */g, function(a, d, e, f) {
        return 0 < e && e + d.length !== f.length && -1 < d.search(c) && ":" !== f.charAt(e - 2) && 0 > f.charAt(e - 1).search(/[^\s-]/) ? a.toLowerCase() : -1 < d.substr(1).search(/[A-Z]|\../) ? a : a.charAt(0).toUpperCase() + a.substr(1);
    });
  }

}
